import { render, staticRenderFns } from "./nav-immersive.vue?vue&type=template&id=790ca9f8"
import script from "./nav-immersive.vue?vue&type=script&lang=js"
export * from "./nav-immersive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports